import { useTranslation } from "react-i18next";
import routes from "../../../../routes/routes";
import { NavLink, useLocation } from "react-router-dom";
import { KeyboardArrowRight } from "@mui/icons-material";
import Button from "../../Button/Button";
import platformTour from "../../../../assets/platform/platformTour2.png";
import { useTheme } from "../../../../theme/ThemeContext";
import { useNavigationContext } from "./NavigationContext";
import Typo from "../../Typo/Typo";

export default function Navigation({ onNavigate = () => null }) {
  const { elements, loading } = useNavigationContext();

  if (loading) return <></>;
  return (
    <div className="Navigation_wrapper">
      <div className="Navigation_aside">
        <PlatformTour />
      </div>
      <nav className="Navigation">
        {elements
          .filter((element) => !element.hidden)
          .map((element, index) => (
            <NavigationTab key={index} onNavigate={onNavigate} {...element} />
          ))}
      </nav>
    </div>
  );
}

function NavigationTab({ path, icon, title, subheading, onNavigate }) {
  const location = useLocation();
  const { theme } = useTheme();

  return (
    // Notes:
    // NavLink adds its own "active" class to <a></a> based on current path.
    // If necessary, reloadDocument prop can be added to NavLink to handle external urls.
    <NavLink
      className={["NavigationTab", theme ? "disableActive" : ""]
        .filter(Boolean)
        .join(" ")}
      onClick={() => onNavigate()}
      state={{ prevPathname: location.pathname }} // state doesn't work when page is reloaded
      to={path}
    >
      <NavigationTabIcon>{icon}</NavigationTabIcon>
      <NavigationTabText>
        <Typo className="NavigationTab-text-title">{title}</Typo>
        <Typo className="NavigationTab-text-subheading">{subheading}</Typo>
      </NavigationTabText>
    </NavLink>
  );
}

function NavigationTabIcon({ children }) {
  return <div className="NavigationTab-icon">{children}</div>;
}

function NavigationTabText({ children }) {
  return <div className="NavigationTab-text">{children}</div>;
}

function PlatformTour() {
  const { t } = useTranslation(["common", "navigation"]);
  return (
    <div className="PlatformTour">
      <img src={platformTour} alt="Platform" />
      <Typo className="PlatformTour-title">
        {t("navigation:platformTour.title")}
      </Typo>
      <Typo className="PlatformTour-subtitle">
        {t("navigation:platformTour.subtitle")}
      </Typo>
      <Button
        icon={<KeyboardArrowRight />}
        text={t("navigation:platformTour.button")}
        onClick={() => (window.location.href = `mailto:${routes.EmailSupport}`)}
      />
    </div>
  );
}
